import { render, staticRenderFns } from "./StudentsWithPhoto.vue?vue&type=template&id=9b1623c6&scoped=true"
import script from "./StudentsWithPhoto.vue?vue&type=script&lang=js"
export * from "./StudentsWithPhoto.vue?vue&type=script&lang=js"
import style0 from "./StudentsWithPhoto.vue?vue&type=style&index=0&id=9b1623c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1623c6",
  null
  
)

export default component.exports